import { FC } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/HomePage/SecuritySection.styl'
import SvgIcon from 'components/atoms/SvgIcon'
import SuccessSvg from 'icons/success.svg'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import Button from 'components/features/pfm/Button/Button'
import { AnalyticsClick } from 'components/features/pfm/AnalyticsClick/AnalyticsClick'

const SecuritySection: FC = () => {
  const iconChild = (
    <div className={ styles.iconWrapper }>
      <div className={ styles.icon }>
        <SvgIcon src={ SuccessSvg } />
      </div>
    </div>
  )
  return (
    <section className={ cn(styles.securitySection) }>
      <div className={ styles.contentWrapper }>
        <h2 className={ styles.header }>Private and Secure</h2>
        <p className={ styles.paragraph }>
          We use bank-grade security standards and 256-bit encryption to protect your data. Your personal information is kept private and never sold to anyone.
        </p>
        <ul className={ styles.pros }>
          <li className={ styles.pro }>
            { iconChild }
            Bank-grade<br className={ styles.proBreak } /> Security
          </li>
          <li className={ styles.pro }>
            { iconChild }
            We'll never sell<br className={ styles.proBreak } /> your data
          </li>
          <li className={ styles.pro }>
            { iconChild }
            Trusted by<br className={ styles.proBreak } /> 400,000+ members
          </li>
        </ul>
        <div className={ styles.buttonWrapper }>
          <AnalyticsClick category='page_controls-homepage' action='click-security_cta'>
            <NavigationLink to='security'>
              <Button
                style='outlined'
                size='medium'
                shadow='light'
                fullWidth
              >
                Learn More
              </Button>
            </NavigationLink>
          </AnalyticsClick>
        </div>
      </div>
    </section>
  )
}

export default SecuritySection
